import React from 'react'
// استيراد useContext لاستخدام الـ Context API
import { useContext } from 'react';

// استيراد الكونتكست اللي فيه المنتجات والفلاتر
import { ProductsContext } from '../Context/CounterStore';
import { Link } from 'react-router-dom';
import { useCart } from '../Context/Cart'; // ✅ استيراد كونتكست السلة
export default function Products() {
     // استخدام Context عشان نوصل للمنتجات والفانكشن الخاصة بالفلترة
    const { filteredProducts, filterByCategory } = useContext(ProductsContext);
      // استخدام دالة إضافة للسلة من الـ Cart Context
        const { addToCart } = useCart(); // ✅
  return <>
  
        {/* عنوان قسم المنتجات الأحدث */}
        <div className="container text-center py-5">
            <h1>Latest Products</h1>
            <hr />
        </div>

        {/* أزرار فلترة المنتجات حسب التصنيف */}
        <div className="container text-center py-3">
            {/* عند الضغط يتم استدعاء الفانكشن مع النوع المحدد */}
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory('all')}>All</button>
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory("men's clothing")}>Men's Clothing</button>
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory("women's clothing")}>Women's Clothing</button>
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory('jewelery')}>Jewelry</button>
            <button className="btn btn-outline-dark mx-2" onClick={() => filterByCategory('electronics')}>Electronics</button>
        </div>

        

       {/* الحاوية الرئيسية اللي فيها كل المنتجات */}
<div className="container">

    {/* صف من الأعمدة - فيه المنتجات وكل كارت */}
    <div className="row justify-content-center">

        {/* تكرار عرض المنتجات اللي جايه من الـ context */}
        {filteredProducts.map((product) => (

            // عمود لكل منتج - ربع عرض الصفحة على الشاشات الكبيرة ونصفها على الشاشات الصغيرة
            <div key={product.id} className="col-md-3 col-sm-6 mb-4 d-flex justify-content-center">

                {/* كارت المنتج - ارتفاع تلقائي وظل خفيف مع حجم ثابت */}
                <div className="card h-100 shadow-sm" style={{ width: '100%', maxWidth: '250px', borderRadius: '8px' }}>

                    {/* صورة المنتج - محاطة بـ padding وتتناسب في الحجم */}
                    <img src={product.image}className="card-img-top p-3"style={{ height: '200px', objectFit: 'contain' }}alt={product.title}/>

                    {/* جسم الكارت - فيه التفاصيل والأزرار */}
                    <div className="card-body d-flex flex-column justify-content-between">

                        {/* الجزء العلوي - العنوان والوصف والسعر */}
                        <div>
                            {/* عنوان المنتج - يظهر أول 20 حرف فقط */}
                            <h6 className="card-title" style={{ fontSize: '14px', fontWeight: 'bold' }}>
                                {product.title.slice(0, 20)}...
                            </h6>

                            {/* وصف قصير للمنتج - أول 60 حرف */}
                            <p className="card-text text-muted" style={{ fontSize: '12px', marginTop: '5px' }}>
                                {product.description.slice(0, 30)}...
                            </p>

                            {/* سعر المنتج بلون أخضر مميز */}
                            <p className="card-text mt-2" style={{ fontSize: '16px', color: '#28a745', fontWeight: 'bold' }}>
                                ${product.price}
                            </p>
                        </div>

                        {/* الجزء السفلي - أزرار الشراء والإضافة للسلة */}
                        <div className="mt-3">
                             <Link  to={`/product/${product.id}`}>
                                  <button className="btn btn-outline-dark btn-sm me-3">Buy Now</button>
                              </Link>
                                   <button 
                                        className="btn btn-outline-dark btn-sm"
                                        // ✅ عند الضغط نضيف المنتج للسلة
                                        onClick={() => addToCart(product)}> Add to Cart
                                        </button>
                        </div>

                    </div>
                </div>
            </div>
        ))}
    </div>
</div>
  </>
}
